// Import SVG so it can be referenced correctly
const iconCheck = new URL('../../images/icon-check.svg', import.meta.url);

class SuccessView {
  constructor() {
    this._parentEl = document.querySelector('#modal');
  }

  render() {
    // 1) Clear parent container
    this._parentEl.innerHTML = '';

    // 2) Create markup
    const markup = `
      <div class="modal__content ta-center">
        <img src="${iconCheck}" alt="">

        <h2 class="heading heading--secondary mt-medium">
          Thanks for your support!
        </h2>

        <p class="paragraph">
          Your pledge brings us one step closer to sharing Mastercraft Bamboo Monitor Riser worldwide. You will get
          an email once our campaign is completed.
        </p>

        <button class="btn btn-primary mt-medium close-modal">Got it!</button>
      </div>
    `;

    // 3) Add elements to the DOM
    this._parentEl.insertAdjacentHTML('afterbegin', markup);

    // 4) Make parent element visible
    this._parentEl.classList.add('is-open');

    // 5) Bind click handler to close button
    this._parentEl
      .querySelector('.close-modal')
      .addEventListener('click', this._hide.bind(this));
  }

  _hide() {
    // 1) Remove content from parent
    this._parentEl.innerHTML = '';

    // 2) Make parent invisible
    this._parentEl.classList.remove('is-open');
  }
}

export default new SuccessView();
